import { Flex, Text } from '@chakra-ui/react';
import { Icon } from '@diamond/shared/ui';
import { NewReleasesOutlined } from '@mui/icons-material';

type DistributionRule = {
  channels: string[];
  weekdayTime: string;
  saturdayTime: string;
  timezone?: string;
};

const rules: DistributionRule[] = [
  {
    channels: ['DA', 'CA'],
    weekdayTime: '15:00',
    saturdayTime: '10:30',
  },
  {
    channels: [
      'DC',
      'DN',
      'DI',
      'DE',
      'DM',
      'DS',
      'DF',
      'DU',
      'DG',
      'DO',
      'DP',
      'DT',
    ],
    weekdayTime: '17:00',
    saturdayTime: '12:00',
  },
  {
    channels: ['DR'],
    weekdayTime: '16:00',
    saturdayTime: '12:00',
  },
  {
    channels: ['DH'],
    weekdayTime: '16:00',
    saturdayTime: '14:00',
    timezone: 'WITA',
  },
  {
    channels: ['DJ', 'DD', 'DK', 'DL', 'DV'],
    weekdayTime: '16:00',
    saturdayTime: '11:00',
  },
];

export function DistributionMessage({
  distributionChannel,
}: {
  distributionChannel: string;
}) {
  const rule = rules.find((r) => r.channels.includes(distributionChannel));

  if (!rule) {
    return null;
  }

  const { weekdayTime, saturdayTime, timezone } = rule;

  return (
    <Flex
      gap="2"
      bg="#f2f2f7"
      p={{ base: '2', md: '4' }}
      borderRadius="8px"
      alignItems={{ base: 'unset', md: 'center' }}
      fontSize={{ base: 'xs', md: 'md' }}
    >
      <Icon as={NewReleasesOutlined} color="blue" />
      <Text>
        Pesanan & unggah bukti transfer di atas jam{' '}
        <Text as="b">
          {weekdayTime}
          {timezone ? ` ${timezone}` : ''}
        </Text>{' '}
        <Text as="b">(Senin-Jumat)</Text> & jam{' '}
        <Text as="b">
          {saturdayTime}
          {timezone ? ` ${timezone}` : ''}
        </Text>{' '}
        <Text as="b">(Sabtu)</Text> akan diproses pada hari kerja selanjutnya.
        Pengiriman <Text as="b">H+1</Text> setelah diproses.
      </Text>
    </Flex>
  );
}

export default DistributionMessage;
